import { render, staticRenderFns } from "./Squads.vue?vue&type=template&id=2ac18e17&scoped=true"
import script from "./Squads.vue?vue&type=script&lang=js"
export * from "./Squads.vue?vue&type=script&lang=js"
import style0 from "./Squads.vue?vue&type=style&index=0&id=2ac18e17&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac18e17",
  null
  
)

export default component.exports